import DesktopDashboardIcon from './DesktopDashboardIcon'

export default DesktopDashboardIcon
